module.exports = __webpack_public_path__ + "static/media/ArchivedFolderFilesFolder.c6ffa998.svg";